import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";
import { z } from "zod";

import { Route as DetailsRequisitesRoute } from "@app/navigation/routes/_private/requisites/$id";
import { requisitesListQueryOptions } from "@entities/requisites";
import { RequisitesPageConnector } from "@pages/requisites";

export const Route = createFileRoute("/_private/requisites/")({
  component: RouteComponent,
  loader: async ({ context }) => {
    return await context.queryClient.ensureInfiniteQueryData(
      requisitesListQueryOptions({}),
    );
  },
  validateSearch: z.object({
    state: z.enum(["add"]).optional(),
  }),
});

function RouteComponent() {
  const navigate = useNavigate();
  const router = useRouter();

  const handleGoDetailsRequisites = useCallback(
    async (id: string) => {
      await navigate({
        params: { id },
        to: DetailsRequisitesRoute.fullPath,
      });
    },
    [navigate],
  );
  const getDetailsHref = useCallback(
    (id: string) =>
      router.buildLocation({
        params: { id },
        to: DetailsRequisitesRoute.fullPath,
      }).href,
    [router],
  );
  const { state } = Route.useSearch();
  return (
    <RequisitesPageConnector
      getDetailsHref={getDetailsHref}
      state={state}
      onGoBack={router.history.back}
      onGoDetails={handleGoDetailsRequisites}
    />
  );
}
